<template>
    <div class="vehicle-provider-details mb-5">
        <div class="row">
            <div class="col-12 mb-4">
                <h3>{{ $t('cdb.subscriptions.vehicle_provider.heading') }}</h3>
                <p>{{ $t('cdb.subscriptions.vehicle_provider.note') }}</p>
            </div>

            <div class="col-12 col-xl-6 mb-3 px-0" v-if="providerData.vehicle.address.branch_email">
                <data-entry-column :title="$t('cdb.profile.form.email.label')" :value="providerData.vehicle.address.branch_email" :full-width="true"></data-entry-column>
            </div>

            <div class="col-12 col-xl-6 mb-3 px-0" v-if="providerData.subsidiary_telephone">
                <data-entry-column :title="$t('co.personal_data.telephone')" :value="providerData.subsidiary_telephone" :full-width="true"></data-entry-column>
            </div>

            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.vehicle_provider.main_branch')" :full-width="true">
                    <template v-if="providerData" v-slot:value>
                        <component
                            v-bind:is="getAddressComponent"
                            :address="providerAddress"
                        ></component>
                    </template>
                </data-entry-column>
            </div>
        </div>
    </div>
</template>
<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import AddressBox from "./AddressBox.vue";

export default {
    name: 'VehicleProviderDetails',
    components: {AddressBox, DataEntryColumn},
    props: {
        providerData: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            providerAddress: this.getAddressObject,
        }
    },
    methods: {
        getAddressObject() {
            this.providerAddress.street = this.$root.whitelabel.state.contact.address.street
            this.providerAddress.house_number = this.$root.whitelabel.state.contact.address.house_nr
            this.providerAddress.postal_code = this.$root.whitelabel.state.contact.address.plz
            this.providerAddress.city = this.$root.whitelabel.state.contact.address.city
            this.providerAddress.region = this.$root.whitelabel.state.contact.address.region
            this.providerAddress.country = this.$root.whitelabel.state.contact.address.country
        } 
    },
    computed: {
        getAddressComponent() {
            this.getAddressObject();
            return "address-box";
        }
    }
}
</script>
